export default "__VITE_ASSET__Dt1str5a__"